import React from 'react';
import SectionHeading from './SectionHeading';
import ExpandableText  from './ExpandableText';
import parser from 'html-react-parser';

export default function Experience({ data }) {
  const { sectionHeading, allExperience } = data;

  return (
    <section className="section gray-bg" id='qualifications'>
      <div className="container">
        <SectionHeading
          miniTitle={sectionHeading.miniTitle}
          title={sectionHeading.title}
        />
        <div className="row gy-3">
          {allExperience?.map((item, index) => (
            <div
              className="col-12"
              key={index}
              data-aos="fade-up"
            >
              <div className="ex-box">
                <div className="row gy-4">
                  <div className="col-md-4 col-lg-3">
                    <div className="ex-left less-padding bg-grey">
                      <img className='rounded' src={item.schoolImage} alt={item.schoolTitle}></img>
                    </div>
                  </div>
                  <div className="col-md-8 col-lg-9">
                    <div className="ex-right">
                      <h5>{parser(item.grade)}</h5>
                      <h4>{item.school}, {item.location}</h4>
                      <p className="m-0">{item.duration}</p>
                      <label>{item.tag}</label>
                    </div>
                  </div>
                  <ExpandableText description={item.schoolDescription} />
                  {/* <div className="col-12">
                    <div className="ex-right">
                      {item.schoolDescription?.map((descp_item, descp_index, arr) => (
                        <p className={descp_index === arr.length - 1 ? "m-0" : ""}>{descp_item}</p>
                      ))}
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
